export default {
	"toMarketing.ParameterError": "Parameter error!",
	"toMarketing.CallIsComing": "Call is coming..."
}